// Copyright (c) 2016 Deere & Company

import details from './details';

export default {
    details
};



// WEBPACK FOOTER //
// ./src/customer/details/reducers/index.js